import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { WebSocketProvider } from './hooks/useWebSocket';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import DeviceDetail from './pages/DeviceDetail';
import DeviceMap from './pages/DeviceMap';
import Alerts from './pages/Alerts';
import Patients from './pages/Patients';
import PatientDetail from './pages/PatientDetail';
import Users from './pages/Users';
import Firmware from './pages/Firmware';
import Setup from './pages/Setup';
import NotificationLog from './pages/NotificationLog';
import Templates from './pages/Templates';
import AuditLog from './pages/AuditLog';
import MonitorDashboard from './pages/MonitorDashboard';
import Reports from './pages/Reports';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-secondary-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="devices" element={<Devices />} />
            <Route path="devices/:id" element={<DeviceDetail />} />
            <Route path="map" element={<DeviceMap />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/:id" element={<PatientDetail />} />
            <Route path="users" element={<Users />} />
            <Route path="firmware" element={<Firmware />} />
            <Route path="setup" element={<Setup />} />
            <Route path="notifications" element={<NotificationLog />} />
            <Route path="templates" element={<Templates />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="monitor" element={<MonitorDashboard />} />
            <Route path="reports" element={<Reports />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </WebSocketProvider>
    </AuthProvider>
  );
}
